import {
  SuggestionItemContainer,
  SuggestionItemControls,
  SuggestionItemSection,
  SuggestionItemSliderContainer,
} from './BinSuggestions.styled'
import { Radio, Slider } from 'components/ui'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { SuggestedBins } from '../../../../../../types'
import { displayedBinAttributes } from './BinSuggestions'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../store'

type BinSuggestionItemProps = {
  suggestedBin?: SuggestedBins
  isSelected?: boolean
  disabled?: boolean
  onClick: () => void
}

export const BinSuggestionItem = ({
  suggestedBin,
  isSelected,
  disabled,
  onClick,
}: BinSuggestionItemProps) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.down('xl'))
  const { isSideNavOpen } = useSelector((state: RootState) => state.sideNav)
  const renderAttributes =
    !isSmallScreen && !(isSideNavOpen && isLargeScreen && !isMediumScreen)

  if (!suggestedBin) {
    return <div />
  }

  return (
    <SuggestionItemContainer>
      <SuggestionItemControls
        sx={{
          pointerEvents: disabled ? 'none' : 'auto',
          width: '180px',
        }}
        onClick={!disabled ? onClick : undefined}
      >
        <Box>
          <Radio readOnly={true} checked={isSelected} />
        </Box>
        <Typography
          sx={{
            color: isSelected
              ? theme.palette.primary.main
              : theme.palette.text.primary,
            fontWeight: isSelected ? 500 : 300,
          }}
          fontSize="19px"
          fontWeight={300}
        >
          {suggestedBin?.bin?.name}
        </Typography>
      </SuggestionItemControls>
      {renderAttributes &&
        suggestedBin.bin.attributes
          .filter((attribute) =>
            displayedBinAttributes.includes(attribute.name)
          )
          .map((attribute, index) => {
            return (
              <SuggestionItemSection
                key={attribute?.name}
                sx={{
                  width: index === 2 ? 120 : 105,
                }}
              >
                {attribute?.range_min} - {attribute?.range_max}
              </SuggestionItemSection>
            )
          })}
      <SuggestionItemSliderContainer>
        {suggestedBin?.is_target ? (
          <Typography
            sx={{
              fontWeight: '700',
            }}
          >
            Target Bin
          </Typography>
        ) : (
          <Slider
            value={suggestedBin.probability}
            min={0}
            max={10}
            customColor={
              suggestedBin.probability > 3
                ? suggestedBin.probability > 7
                  ? theme.palette.success.light
                  : theme.palette.warning.light
                : theme.palette.error.light
            }
          />
        )}
      </SuggestionItemSliderContainer>
    </SuggestionItemContainer>
  )
}
